import { CardComp } from "../..";

export function DetailSection({ title, children, className = "" }) {
  return (
    <CardComp cardClassName={`border-0 shadow-sm mb-3 ${className}`}>
      {title ? <h6 className="investor-portal-section-title">{title}</h6> : null}
      {children}
    </CardComp>
  );
}

export function DetailField({ label, children, value }) {
  return (
    <div className="investor-portal-detail-field">
      <span className="investor-portal-detail-label">{label}</span>
      <div className="investor-portal-detail-value">{children ?? value}</div>
    </div>
  );
}

export function DetailFieldList({ children }) {
  return <div className="investor-portal-detail-fields">{children}</div>;
}
